/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function qaalyRefreshVibe(cart) {
  const cartVariantIds = cart.items.map(item => String(item.variant_id));
  const vibeCards = document.querySelectorAll('.qaaly-cart-vibe-product');

  let shown = 0;

  vibeCards.forEach(card => {
    const variantId = card.dataset.vibeVariantId;
    const inCart = cartVariantIds.includes(String(variantId));

    if (!inCart && shown < 3) {
      card.style.display = '';
      shown++;
    } else {
      card.style.display = 'none';
    }
  });
}
fetch('/cart.js')
  .then(r => r.json())
  .then(cart => qaalyRefreshVibe(cart));
  document.addEventListener('submit', async function(event) {
  const form = event.target.closest('.qaaly-cart-vibe-product__form');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('.qaaly-cart-vibe-product__add');
  const card = form.closest('.qaaly-cart-vibe-product');
  const formData = new FormData(form);

  if (!button || button.classList.contains('is-loading')) return;

  button.classList.add('is-loading');
  button.textContent = '...';

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });

    if (!response.ok) throw new Error('Add failed');

    const cart = await fetch('/cart.js').then(r => r.json());
    qaalyRefreshVibe(cart);
    const drawerHtml = await fetch('/?section_id=api-cart-items').then(r => r.text());
const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');

const newItems = doc.querySelector('[data-api-line-items]');
const currentItems = document.querySelector('[data-items-holder]');

if (newItems && currentItems) {
  currentItems.innerHTML = newItems.innerHTML;
}

    const money = '$' + (cart.total_price / 100).toFixed(2) + ' USD';

    document.querySelectorAll('[data-cart-total-price]').forEach(el => {
      el.textContent = money;
    });

    document.querySelectorAll('.qaaly-cart-subtotal-row strong').forEach(el => {
      el.textContent = money;
    });

    document.querySelectorAll('[data-cart-items-qty]').forEach(el => {
      el.textContent = `(${cart.item_count} items)`;
      el.classList.remove('hidden');
    });

    const donationText = document.querySelector('.qaaly-cart-donation-panel__text strong');
    if (donationText) {
      donationText.textContent = '$' + (cart.item_count * 5);
    }

    button.textContent = '✓';
    card?.classList.add('qaaly-vibe-added');

    setTimeout(() => {
      qaalyRefreshVibe(cart);
    }, 450);

  } catch (error) {
    console.error('Qaaly vibe add error:', error);
    button.textContent = '+';
  }

  button.classList.remove('is-loading');
});
document.addEventListener('click', async function(event) {
  const removeButton = event.target.closest('[data-item-remove]');
  if (!removeButton) return;

  event.preventDefault();

  const item = removeButton.closest('[data-cart-item]');
  const line = item?.getAttribute('data-item-index');

  if (!line) return;

  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: Number(line),
        quantity: 0
      })
    });

    const cart = await fetch('/cart.js').then(r => r.json());
    qaalyRefreshVibe(cart);
    const money = '$' + (cart.total_price / 100).toFixed(2) + ' USD';

    item.remove();
    const drawerHtml = await fetch('/?section_id=api-cart-items').then(r => r.text());
const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');

const newItems = doc.querySelector('[data-api-line-items]');
const currentItems = document.querySelector('[data-items-holder]');

if (newItems && currentItems) {
  currentItems.innerHTML = newItems.innerHTML;
}

const newVibe = doc.querySelector('.qaaly-cart-vibe-card--products');
const currentVibe = document.querySelector('.qaaly-cart-vibe-card--products');

if (newVibe && currentVibe) {
  currentVibe.innerHTML = newVibe.innerHTML;
}

    document.querySelectorAll('[data-cart-total-price], .qaaly-cart-subtotal-row strong').forEach(el => {
      el.textContent = money;
    });

    document.querySelectorAll('[data-cart-items-qty]').forEach(el => {
      el.textContent = `(${cart.item_count} items)`;
    });

    const donationText = document.querySelector('.qaaly-cart-donation-panel__text strong');
    if (donationText) {
      donationText.textContent = '$' + (cart.item_count * 5);
    }

  } catch (error) {
    console.error('Qaaly remove error:', error);
  }
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
